import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["name", "label", "currencyLabel", "defaultValue", "inputClassName", "lang", "errorLabel", "maxLength", "inputContainerClassName", "labelClassName", "disallowZero"];
import React from "react";
var __jsx = React.createElement;
import { Controller, useFormContext } from "react-hook-form";
import InputCurrency from "@/componentsShared/InputCurrency/InputCurrency";
import { useTranslation } from "@i18n";
var RHFInputCurrency = function RHFInputCurrency(_ref) {
  var name = _ref.name,
    label = _ref.label,
    currencyLabel = _ref.currencyLabel,
    defaultValue = _ref.defaultValue,
    inputClassName = _ref.inputClassName,
    _ref$lang = _ref.lang,
    lang = _ref$lang === void 0 ? "ar" : _ref$lang,
    errorLabel = _ref.errorLabel,
    _ref$maxLength = _ref.maxLength,
    maxLength = _ref$maxLength === void 0 ? 11 : _ref$maxLength,
    inputContainerClassName = _ref.inputContainerClassName,
    labelClassName = _ref.labelClassName,
    _ref$disallowZero = _ref.disallowZero,
    disallowZero = _ref$disallowZero === void 0 ? false : _ref$disallowZero,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement(Controller, {
    name: name,
    control: control,
    defaultValue: defaultValue || 0,
    render: function render(_ref2) {
      var field = _ref2.field,
        error = _ref2.fieldState.error;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputCurrency, _extends({
        inputClassName: inputClassName,
        defaultValue: field.value,
        currencyLabel: currencyLabel,
        label: label,
        onChange: field.onChange,
        lang: lang,
        maxLength: maxLength,
        errorLabel: "",
        inputContainerClassName: inputContainerClassName,
        labelClassName: labelClassName,
        disallowZero: disallowZero
      }, props)), error && /*#__PURE__*/React.createElement("span", {
        className: "text-danger text-xs"
      }, tShort(error.message, {
        ns: "validations"
      })));
    }
  });
};
export default RHFInputCurrency;